module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In 2013, I was sitting in the Aircrewmen’s Crew room of 848 Naval Air Commando Squadron at Royal Naval Air Station Yeovilton (RNAS Yeovilton). All the crewman were telling stories (DITs); I joined in and Buck Taylor, one of the instructors, said I should write a book as the DITs went on for quite a while, and the fact that I had been around the job for some forty-five years then (I joined in 1968) meant I had a few stories to tell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So, I have decided to do as he asked and we’ll see how it goes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a63ff58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Forword.vue
// module id = 75
// module chunks = 0